import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'portal.views.dashboard-table.new-claim-report.title',
        defaultMessage: 'New claim report'
    },
    summary: {
        id: 'portal.views.dashboard-table.new-claim-report.summary',
        defaultMessage: 'Summary policy',
    },
    vehicle: {
        id: 'portal.views.dashboard-table.new-claim-report.data-vehicle',
        defaultMessage: 'Data vehicle',
    },
    policyCoverage: {
        id: 'portal.views.dashboard-table.new-claim-report.policy-coverage',
        defaultMessage: 'Policy coverage',
    },
    policyNumber: {
        id: 'portal.views.dashboard-table.new-claim-report.policy-number',
        defaultMessage: 'Policy number',
    },
    effectiveDate: {
        id: 'portal.views.dashboard-table.new-claim-report.effective-date',
        defaultMessage: 'Effective date',
    },
    policiStatus: {
        id: 'portal.views.dashboard-table.new-claim-report.policy-status',
        defaultMessage: 'Policy status',
    },
    insured: {
        id: 'portal.views.dashboard-table.new-claim-report.insured',
        defaultMessage: 'Insured name',
    },
    expiration: {
        id: 'portal.views.dashboard-table.new-claim-report.expiration-date',
        defaultMessage: 'Expiration date',
    },
    collection: {
        id: 'portal.views.dashboard-table.new-claim-report.policy-collection-status',
        defaultMessage: 'Policy collection',
    },
    make: {
        id: 'portal.views.dashboard-table.new-claim-report.vehicle-data.make',
        defaultMessage: 'Make',
    },
    year: {
        id: 'portal.views.dashboard-table.new-claim-report.vehicle-data.year',
        defaultMessage: 'Year',
    },
    serialNumber: {
        id: 'portal.views.dashboard-table.new-claim-report.vehicle-data.serial-number',
        defaultMessage: 'Serial number',
    },
    model: {
        id: 'portal.views.dashboard-table.new-claim-report.vehicle-data.model',
        defaultMessage: 'Model',
    },
    licensePlate: {
        id: 'portal.views.dashboard-table.new-claim-report.vehicle-data.license-plate',
        defaultMessage: 'License plate',
    },
    vehicleType: {
        id: 'portal.views.dashboard-table.new-claim-report.vehicle-data.vehicle-type',
        defaultMessage: 'Vehicle type'
    },
    coverage: {
        id: 'portal.views.dashboard-table.new-claim-report.coverage',
        defaultMessage: 'Coverage',
    },
    insuredAmount: {
        id: 'portal.views.dashboard-table.new-claim-report.coverage.insured-amount',
        defaultMessage: 'Insured amount',
    },
    deductible: {
        id: 'portal.views.dashboard-table.new-claim-report.coverage.deductible',
        defaultMessage: 'Deductible'
    },
    lossDateHelpTextMsg: {
        id: 'portal.views.dashboard-table.new-claim-report.ClaimLossDateHelpText_AX',
        defaultMessage: 'Loss date entered in the previous step. Go back if you need to change it'
    },
    assists: {
        id: 'portal.views.dashboard-table.new-claim-report.assists',
        defaultMessage: 'Assistances'
    },
    assistslimit: {
        id: 'portal.views.dashboard-table.new-claim-report.assists-limit',
        defaultMessage: 'Assistes limit'
    },
    assistsUsed: {
        id: 'portal.views.dashboard-table.new-claim-report.assists-used',
        defaultMessage: 'Assistes used'
    },
    assistsdescription: {
        id: 'portal.views.dashboard-table.new-claim-report.assists.assists-description',
        defaultMessage: 'Description'
    },
    specialConditions: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions',
        defaultMessage: 'Special conditions'
    },
    specialConditionsFolio: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions.folio',
        defaultMessage: 'Folio'
    },
    specialConditionsRfc: {
        id: 'portal.views.dashboard-table.new-claim-report.special-conditions.rfc',
        defaultMessage: 'Name / Bussine name'
    },
    warning: {
        id: 'portal.views.dashboard-table.new-claim-report.warning_AX',
        defaultMessage: 'Attention:'
    },
    noAssistanceCoverage: {
        id: 'portal.views.dashboard-table.new-claim-report.noAssistanceCoverage_AX',
        defaultMessage: 'This policy does not cover the coverage "Assistance Services"'
    },
    assistanceLabel: {
        id: 'portal.views.dashboard-table.new-claim-report.ClaimAssistance',
        defaultMessage: 'Assistance'
    },
    error: {
        id: 'portal.views.dashboard-table.new-claim-report.alert.nag.message.error',
        defaultMessage: 'Error'
    },
    errorMessage: {
        id: 'portal.views.dashboard-table.new-claim-report.message.errorMessage',
        defaultMessage: 'Please try again later!'
    },
    isRoad: {
        id: 'ax_portal.views.dashboard-table.new-claim-report.isRoad',
        defaultMessage: 'Is it road?'
    },
    searchLocation: {
        id: 'ax_portal.views.dashboard-table.new-claim-report.searchLocation',
        defaultMessage: 'Search location'
    },
    location: {
        id: 'ax_portal.views.dashboard-table.new-claim-report.location',
        defaultMessage: 'location'
    }
});
